import myAxiosV2 from "./apiV2";

const baseUrl = "/admin";

const Question = {
  // Get all existing questions
  // GET /admin/questions
  getAll(query = null) {
    return myAxiosV2.get(`${baseUrl}/questions?${query ? query : ""}`);
  },

  // Get question by ID
  // GET /admin/questions/{id}
  getById(id) {
    return myAxiosV2.get(`${baseUrl}/questions/${id}`);
  },

  // Get questions by location ID
  // GET /admin/questions/location/{locationId}
  getByLocationId(locationId) {
    return myAxiosV2.get(`${baseUrl}/questions/location/${locationId}`);
  },

  // Create new questions (POST array of questions)
  // POST /admin/questions
  // Payload: [{ locationId: [1,2], question: "...", options: ["yes","no"], type: "radiobutton" }]
  create(data) {
    return myAxiosV2.post(`${baseUrl}/questions`, data);
  },

  // Update existing question by ID
  // PUT /admin/questions/{id}
  // Payload: { locationIds: [1,3], question: "...", options: ["yes","no"], type: "checkbox" }
  update(id, data) {
    return myAxiosV2.put(`${baseUrl}/questions/${id}`, data);
  },

  // Delete question by ID
  // DELETE /admin/questions/{id}
  delete(id) {
    return myAxiosV2.delete(`${baseUrl}/questions/${id}`);
  },
};

export default Question;
